import { ChangeEvent } from "react";
import { resources } from "@constants/hardcoded-strings";
import { TextareaFormGroup } from "@containers/common/textarea-form-group/textarea-form-group";
import { ThemingFormSection } from "@containers/common/theming-form-section/theming-form-section";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { FormattedEmailTemplate } from "@idw-types/data/email-template";
import commonStyles from "../../email-template-details-component.less";
import styles from "./email-template-content-form-section.less";
import { EmailTemplateContentValidationErrors } from "@idw-types/common/validation/email-template/email-template-validation-errors";

type EmailTemplateContentFormSectionProps = {
    state: FormattedEmailTemplate;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    validationErrors: EmailTemplateContentValidationErrors;
    handleUpdateTemplate: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const EmailTemplateContentFormSection = (props: EmailTemplateContentFormSectionProps) => {
    const {
        state,
        isDisabled,
        labelWidth,
        validationErrors,      
        handleUpdateTemplate
    } = props;

    const resource = resources.pages.emailTemplateDetails.tabs.content;
    return (
        <ThemingFormSection title={resource.sections.template.title}>
            <div className={commonStyles.sectionDescription}>{resource.sections.template.description}</div>
            <TextareaFormGroup
                className={styles.expandedTextArea}
                controlId="email-template-template-input"
                automationId="email-template-template-input"
                label={resource.inputs.template.label}
                ariaLabel={resource.inputs.template.label}
                placeholder={resource.inputs.template.placeholder}
                value={state.template}
                onChange={handleUpdateTemplate}
                disabled={isDisabled}
                isRequired={true}
                labelWidth={labelWidth}
                layout={LayoutTypes.COLUMN}
            />
            {validationErrors?.requiredVariableError}
        </ThemingFormSection>
    );
}